import { render, staticRenderFns } from "./thirdurl.vue?vue&type=template&id=15701922&"
import script from "./thirdurl.vue?vue&type=script&lang=js&"
export * from "./thirdurl.vue?vue&type=script&lang=js&"
import style0 from "./thirdurl.vue?vue&type=style&index=0&id=15701922&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports